import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'

import { getRoundedValue, formatExponent } from './../utils'
import { Scale as HypScale } from '@hyperobjekt/scales'
import '@hyperobjekt/scales/dist/style.css'
import ScalePointIcon from '../../../assets/Icons/ScalePointIcon'
import ScaleTrianglesIcon from '../../../assets/Icons/ScaleTrianglesIcon'
import {
  useTheme,
  useMediaQuery,
  Typography,
} from '@material-ui/core'
import clsx from 'clsx'

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(2),
    '& .domain, .HypScale-ticks line': {
      color: theme.extras.variables.colors.faintGray,
    },
    '& .HypScale-markerWrapper': {
      // center marker on line
      // cancels out this px https://github.com/Hyperobjekt/scales/blob/4e2fbf080c7e5c97104fb208e09be3d24f7a00d6/src/Scales/Ticks.jsx#L72
      transform: 'translateY(1px)',
    },
    '&:not(.reverse) .HypScale-ticks': {
      '& g.tick text': {
        textAnchor: 'start',
      },
      '& g.tick:last-child text': {
        textAnchor: 'end',
      },
    },
    '&.reverse .HypScale-ticks': {
      '& g.tick text': {
        textAnchor: 'end',
      },
      '& g.tick:last-child text': {
        textAnchor: 'start',
      },
    },
  },
  label: {
    // fontSize: '0.75rem',
    position: 'absolute',
    fontWeight: 400,
    top: -26,
  },
}))

const getValueLabel = (
  value,
  decimals,
  currency,
  percent,
) =>
  String(value).indexOf('e') > 0
    ? formatExponent(value)
    : getRoundedValue(
        value,
        decimals,
        true,
        currency,
        percent,
      )

const LinearScale = ({ value, meta = {} }) => {
  const classes = useStyles()

  const high_is_good = !!meta.high_is_good
  const currency = !!meta.currency
  const capped = !!meta.capped
  const column = !!meta.column
  const decimals = Number(meta.decimals)
  const percent = false
  // const alt_u = meta.alt_u
  const min = Number(meta.min)
  const max = Number(meta.max)
  const mean = Number(meta.mean)

  const valueLabel = getValueLabel(
    value,
    decimals,
    currency,
    percent,
  )

  // Preserve: For checking a particular indicator, if there are issues with its presentation.
  // if (indicator.id === 'eph') {
  //   console.log(
  //     'eph',
  //     percentFromLeft,
  //     percentFromLeft > 90 &&
  //       String(percentFromLeft).length > 2,
  //     percentFromLeft < 10 &&
  //       String(percentFromLeft).length > 2,
  //   )
  // }

  const theme = useTheme()
  const belowXs = useMediaQuery(
    theme.breakpoints.down('xs'),
  )

  let width = 320
  // adjust width to scale to mobile width available
  // TODO: find a better way
  // TODOxxx: use browserWidth
  if (belowXs) {
    // modal window is 80vw - padding - scrollbar
    width = window.innerWidth * 0.8 - 16 * 2 - 20
  }
  return (
    <HypScale
      reverse={!high_is_good}
      className={clsx(classes.root, column, {
        reverse: !high_is_good,
        capped,
      })}
      min={min}
      max={max}
      margin={{
        bottom: 4,
        left: 18,
        right: 18,
        top: 8,
      }}
      width={width}
      // nice
      type="continuous"
    >
      <HypScale.Marker
        pointer
        renderPointer={ScalePointIcon}
        value={mean}
      />
      <HypScale.Marker
        pointer
        renderPointer={ScaleTrianglesIcon}
        value={value}
      >
        <Typography
          variant="body2"
          className={classes.label}
          title={valueLabel}
        >
          {valueLabel}
        </Typography>
      </HypScale.Marker>

      <HypScale.Ticks
        height={24}
        // className={clsx({ reverse: !high_is_good })}
        tickFormat={v => {
          const fv = getValueLabel(
            v,
            decimals,
            currency,
            percent,
          )
          // if indicator is capped and this is the max value, add +
          return v === max && capped ? fv + '+' : fv
        }}
        tickSize={8}
        endTicks
      />
    </HypScale>
  )
}

LinearScale.propTypes = {
  meta: PropTypes.object,
  value: PropTypes.number,
}

export default LinearScale
